export const CREATIVE_NOTIFICATION_CHANNEL_MESSAGE =
  'ogy:creative-notification-channel';

export interface CreativeNotificationChannelMessage {
  type: typeof CREATIVE_NOTIFICATION_CHANNEL_MESSAGE;
  event: string;
}

export function isCreativeNotificationChannelMessage(
  data: unknown
): data is CreativeNotificationChannelMessage {
  if (typeof data !== 'object' || data === null) {
    return false;
  }
  const message = data as { [key: string]: unknown };
  return (
    message.type === CREATIVE_NOTIFICATION_CHANNEL_MESSAGE &&
    typeof message.event === 'string'
  );
}
